import React from 'react'

export const ServiceListPage = React.lazy(() => import('./list-service'))
